var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "ui-view",
    {
      directives: [
        {
          name: "spinner",
          rawName: "v-spinner",
          value: _vm.loading,
          expression: "loading",
        },
      ],
      staticClass: "view-action-form",
      attrs: { hide: _vm.loading },
    },
    [
      _c(
        "ui-heading",
        { attrs: { title: _vm.pageTitle } },
        [
          _c(
            "ui-button",
            {
              attrs: { color: "positive", loading: _vm.submitting },
              on: {
                click: function ($event) {
                  return _vm.$refs.form.submit()
                },
              },
            },
            [_vm._v("Opslaan")]
          ),
          _c(
            "ui-button",
            {
              attrs: {
                slot: "left",
                color: "medium",
                type: "bordered",
                to: _vm.backRoute,
              },
              slot: "left",
            },
            [_vm._v("Annuleren")]
          ),
        ],
        1
      ),
      _c(
        "ui-form-panel",
        {
          ref: "form",
          attrs: { "auto-validate": "" },
          on: { submit: _vm.submit },
        },
        [
          _c("ui-form-date-input", {
            attrs: { title: "Datum", name: "date", rules: "required" },
            model: {
              value: _vm.pendingSowing.date,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "date", $$v)
              },
              expression: "pendingSowing.date",
            },
          }),
          _c("ui-form-radio", {
            attrs: {
              title: "Zaad type",
              name: "seedType",
              rules: "required",
              options: _vm.seedTypeOptions,
            },
            model: {
              value: _vm.pendingSowing.seedType,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "seedType", $$v)
              },
              expression: "pendingSowing.seedType",
            },
          }),
          _c("ui-form-radio", {
            attrs: {
              title: "Oorsprong locatie",
              name: "originLocation",
              rules: "required",
              options: _vm.originLocationOptions,
            },
            model: {
              value: _vm.pendingSowing.originLocation,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "originLocation", $$v)
              },
              expression: "pendingSowing.originLocation",
            },
          }),
          _c("ui-form-radio", {
            attrs: {
              title: "Oorsprong type",
              name: "originType",
              rules: "required",
              options: _vm.originTypeOptions,
            },
            model: {
              value: _vm.pendingSowing.originType,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "originType", $$v)
              },
              expression: "pendingSowing.originType",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "Visgebied", name: "fishingArea" },
            model: {
              value: _vm.pendingSowing.fishingArea,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "fishingArea", $$v)
              },
              expression: "pendingSowing.fishingArea",
            },
          }),
          _c("ui-form-input", {
            attrs: { title: "MZI gebied", name: "mziArea" },
            model: {
              value: _vm.pendingSowing.mziArea,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "mziArea", $$v)
              },
              expression: "pendingSowing.mziArea",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              number: "",
              title: "MZI: Aantal uur gevist",
              name: "duration",
              suffix: "Uur",
            },
            model: {
              value: _vm.pendingSowing.duration,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "duration", $$v)
              },
              expression: "pendingSowing.duration",
            },
          }),
          _c("ui-form-dropdown", {
            attrs: {
              title: "Herkomst jaar",
              name: "seedYear",
              options: _vm.seedYearOptions,
              rules: "required",
            },
            model: {
              value: _vm.pendingSowing.seedYear,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "seedYear", $$v)
              },
              expression: "pendingSowing.seedYear",
            },
          }),
          _c("ui-form-dropdown", {
            attrs: {
              searchable: "",
              title: "Schip",
              name: "shipId",
              options: _vm.shipOptions,
              empty: "",
            },
            model: {
              value: _vm.pendingSowing.shipId,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "shipId", $$v)
              },
              expression: "pendingSowing.shipId",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              number: "",
              title: "Bruto",
              name: "brutoWeight",
              suffix: "mTon",
            },
            model: {
              value: _vm.pendingSowing.brutoWeight,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "brutoWeight", $$v)
              },
              expression: "pendingSowing.brutoWeight",
            },
          }),
          _c("ui-form-input", {
            attrs: {
              number: "",
              title: "Netto",
              name: "nettoWeight",
              suffix: "mTon",
            },
            model: {
              value: _vm.pendingSowing.nettoWeight,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "nettoWeight", $$v)
              },
              expression: "pendingSowing.nettoWeight",
            },
          }),
          _c("ui-form-input", {
            attrs: { decimal: "", title: "Tarra", name: "tarra", suffix: "%" },
            model: {
              value: _vm.pendingSowing.tarra,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "tarra", $$v)
              },
              expression: "pendingSowing.tarra",
            },
          }),
          _c("ui-form-input", {
            attrs: { number: "", title: "Bustal", name: "bustal" },
            model: {
              value: _vm.pendingSowing.bustal,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "bustal", $$v)
              },
              expression: "pendingSowing.bustal",
            },
          }),
          _c("ui-form-input", {
            attrs: { number: "", title: "Stukstal", name: "stukstal" },
            model: {
              value: _vm.pendingSowing.stukstal,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "stukstal", $$v)
              },
              expression: "pendingSowing.stukstal",
            },
          }),
          _c("ui-form-textarea", {
            attrs: { title: "Bijzonderheden", name: "notes" },
            model: {
              value: _vm.pendingSowing.notes,
              callback: function ($$v) {
                _vm.$set(_vm.pendingSowing, "notes", $$v)
              },
              expression: "pendingSowing.notes",
            },
          }),
        ],
        1
      ),
    ],
    1
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }